import update from 'immutability-helper'
import {DocumentData, QueryDocumentSnapshot, SnapshotOptions} from "firebase/firestore"


export default class Song {
    static converter = {
        toFirestore  : (song: Song): DocumentData => {
            return {
                position: song.position,
                title : song.title,
                artist: song.artist,
                hide  : song.hide,
                played: song.played,
                voted : song.voted,

                addDT : song.addDT || null,
                lastDT: song.lastDT || null
            }
        },
        fromFirestore: (snapshot: QueryDocumentSnapshot<DocumentData>, options?: SnapshotOptions): Song => {
            return new Song(snapshot.id, snapshot.data(options))
        }
    }
    key?: string
    position?: number
    title: string = ''
    artist: string = ''
    hide: boolean = false
    played: number = 0
    voted: number = 0
    sessionVoted?: number
    sessionPlayed?: boolean
    addDT?: Date
    lastDT?: Date

    public constructor(key?: string, data?: DocumentData) {
        if (key && data) {
            this.key = key
            this.position = data.position
            this.title = data.title || ''
            this.artist = data.artist || ''
            this.hide = data.hide || false
            this.played = data.played || 0
            this.voted = data.voted || 0

            this.addDT = data.addDT
            this.lastDT = data.lastDT
        }
    }

    public setArtist(artist: string): Song {
        return update(this as Song, {
            artist: {
                $set: artist
            }
        })
    }

    public setTitle(title: string): Song {
        return update(this as Song, {
            title: {
                $set: title
            }
        })
    }

    public setPosition(position: number | undefined) : Song {
        return update(this as Song, {
            position: {
                $set: position
            }
        })
    }

    public static sortByPosition(a: Song, b: Song) : number {
        if ((a.position === undefined) && (b.position === undefined)) {
            return 0
        }
        if ((a.position === undefined) && (b.position !== undefined)) {
            return 1
        }
        if ((a.position !== undefined) && (b.position === undefined)) {
            return -1
        }

        if ((a.position as number) < (b.position as number)) {
            return -1
        }
        if ((a.position as number) > (b.position as number)) {
            return 1
        }
        return 0
    }
}



